/*
 * Batch-year values in results.js are free text, not a clean enum — some
 * carry a trailing verification flag ("2024-25 [VERIFY_BATCH]") and some are
 * fully unresolved ("[PLACEHOLDER_BATCH]"). This extracts the leading 4-digit
 * year for sorting only; it never rewrites or normalizes the displayed
 * string.
 */
export const parseBatchYearStart = (batchYear) => {
  const match = /^(\d{4})-\d{2}/.exec(batchYear || '');
  return match ? Number(match[1]) : null;
};

// Newest first; entries with no parseable year (placeholders) sort last.
export const compareBatchYearDesc = (a, b) => {
  const yearA = parseBatchYearStart(a);
  const yearB = parseBatchYearStart(b);
  if (yearA === null && yearB === null) return 0;
  if (yearA === null) return 1;
  if (yearB === null) return -1;
  return yearB - yearA;
};
